// extracted by mini-css-extract-plugin
module.exports = {"w1bxxhj6":"w1bxxhj6","react-swipeable-view-container":"react-swipeable-view-container","b1uhfkiz":"b1uhfkiz"};